import type { EmbargoCategoryConfig, EmbargoConfig } from './types';

export const EMBARGO_MODES = {
  CREATE: 'create',
  EDIT: 'edit',
  PROCESS: 'process',
} as const;

export type EmbargoMode = (typeof EMBARGO_MODES)[keyof typeof EMBARGO_MODES];

export const EMBARGO_MESSAGE_KEYS = {
  NON_SERVICE_ZIP: 'nonServiceZip',
  FREEZABLE_LANE_BY_ZIP: 'freezableLaneByZip',
  FREEZABLE_LANE_BY_TERMINAL: 'freezableLaneByTerminal',
} as const;

export type EmbargoMessageKey =
  (typeof EMBARGO_MESSAGE_KEYS)[keyof typeof EMBARGO_MESSAGE_KEYS];

export const EMBARGO_VIOLATION_LEVELS = {
  SHIPMENT: 'shipment',
} as const;

export type EmbargoViolationLevel =
  (typeof EMBARGO_VIOLATION_LEVELS)[keyof typeof EMBARGO_VIOLATION_LEVELS];

export const EMBARGO_VALIDATION_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
} as const;

export type EmbargoValidationType =
  (typeof EMBARGO_VALIDATION_TYPES)[keyof typeof EMBARGO_VALIDATION_TYPES];

export const EMBARGO_SHIPMENT_REVALIDATE_FIELDS = [
  'consigneeZip',
  'consigneeCity',
  'consigneeCode',
  'consigneeName',
  'destinationTerminal',
  'isFreezable',
] as const;

export const createEmptyEmbargoCategory = (): EmbargoCategoryConfig => ({
  values: [],
  validationType: 'error',
});

export const EMPTY_EMBARGO_CONFIG: EmbargoConfig = {
  nonServiceZip: createEmptyEmbargoCategory(),
  freezableLanesByZip: createEmptyEmbargoCategory(),
  freezableLanesByTerminal: createEmptyEmbargoCategory(),
};

export const EMBARGO_CATEGORIES = {
  NON_SERVICE_ZIP: 'nonservicezip',
  FREEZABLE_LANES_BY_ZIP: 'freezablelanesbyzip',
  FREEZABLE_LANES_BY_TERMINAL: 'freezablelanesbyterminal',
} as const;

/**
 * Client-owned severity per GET embargo category.
 * Assigned in toEmbargoConfig; rules read config.*.validationType.
 * Process Pickup upgrades freezable zip to Error when isFreezable is known.
 */
export const EMBARGO_CATEGORY_VALIDATION_TYPES: Record<
  (typeof EMBARGO_CATEGORIES)[keyof typeof EMBARGO_CATEGORIES],
  EmbargoValidationType
> = {
  [EMBARGO_CATEGORIES.NON_SERVICE_ZIP]: EMBARGO_VALIDATION_TYPES.ERROR,
  [EMBARGO_CATEGORIES.FREEZABLE_LANES_BY_ZIP]: EMBARGO_VALIDATION_TYPES.WARNING,
  [EMBARGO_CATEGORIES.FREEZABLE_LANES_BY_TERMINAL]: EMBARGO_VALIDATION_TYPES.WARNING,
};

export const getEmbargoCategoryValidationType = (
  categoryKey: string
): EmbargoValidationType =>
  EMBARGO_CATEGORY_VALIDATION_TYPES[
    categoryKey as keyof typeof EMBARGO_CATEGORY_VALIDATION_TYPES
  ] ?? EMBARGO_VALIDATION_TYPES.ERROR;

/** Backend save failure discriminator — matches IntegrationService error envelope. */
export const EMBARGO_SAVE_ERROR_NAME = 'EmbargoError';
